import Main from './containers/Main/Main';
import Forum from './containers/Forum/Forum';
import ForumTopicCreate from './containers/Forum/ForumTopicCreate';
import ForumTopics from './containers/Forum/ForumTopicList';
import ForumTopic from './containers/Forum/ForumTopic';
import { MyProfile } from './containers/Profile/MyProfile';
import { Profile } from './containers/Profile/Profile';
import { NewsList } from './containers/News/NewsList';
import { GalleryCategoryList } from './containers/Gallery/GalleryCategoryList';
import { NewsDetails } from './containers/News/NewsDetails';
import { GalleryCategoryDetails } from './containers/Gallery/GalleryCategoryDetails';
import Training from './containers/Training/Training';
import Practice from './containers/Contest/Practice';
import PracticeDetail from './containers/Contest/PracticeDetail/PracticeDetail';
import Error404 from './containers/404/Error404';

import paths from './paths';

export default class routes {
  static advocates = [
    { exact: true, path: paths.advocates.main, name: 'Main', component: Main, section: null },
    { exact: true, path: paths.advocates.forum, name: 'Forum', component: Forum, section: 'Forum' },
    { exact: true, path: paths.advocates.forumNewTopic, name: 'ForumTopicCreate', component: ForumTopicCreate, section: 'Forum' },
    { exact: true, path: `${paths.advocates.forumNewTopic}/:alias`, name: 'ForumTopicCreate', component: ForumTopicCreate, section: 'Forum' },
    { exact: true, path: paths.advocates.forumCategories, name: 'ForumTopics', component: ForumTopics, section: 'Forum' },
    { exact: true, path: `${paths.advocates.forumCategories}/:alias`, name: 'ForumTopics', component: ForumTopics, section: 'Forum' },
    { exact: true, path: `${paths.advocates.forumTopic}/:alias`, name: 'ForumTheme', component: ForumTopic, section: 'Forum' },
      { exact: true, path: paths.advocates.news, name: 'News', component: NewsList, section: 'News' },
      { exact: true, path: paths.advocates.gallery, name: 'Gallery', component: GalleryCategoryList, section: 'Gallery' },
      { exact: true, path: `${paths.advocates.news}/:alias`, name: 'NewsDetails', component: NewsDetails, section: 'News' },
      { exact: true, path: `${paths.advocates.gallery}/:alias`, name: 'GalleryCategoryDetails', component: GalleryCategoryDetails, section: 'Gallery' },
    { exact: true, path: paths.advocates.practice, name: 'Practice', component: Practice, section: 'Practice' },
    { exact: true, path: `${paths.advocates.practiceCase}/:alias`, name: 'PracticeDetail', component: PracticeDetail, section: 'Practice' },
    { exact: true, path: paths.advocates.myprofile, name: 'MyProfile', component: MyProfile, section: null },
    { exact: true, path: `${paths.advocates.profile}/:profileId`, name: 'Profile', component: Profile, section: null },
    { exact: true, path: paths.advocates.education, name: 'Training', component: Training, section: 'Education' },
    { exact: true, path: paths.advocates.notFound, name: 'Error404', component: Error404, section: null }
  ];
};